"use client";

import { c as _c } from "react/compiler-runtime";
import { RegularLinkButton } from "@/components/Button/RegularLinkButton/RegularLinkButton.component";
import { TrialFocusPaywallTitle } from "@/components/Paywall/_components/PaywallTitle/TrialFocusPaywallTitle.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
export function AddTrialCard() {
  const $ = _c(12);
  const {
    name: siteName
  } = useSite();
  const {
    relative: relativeUrl
  } = useCurrentUrl();
  const {
    trial
  } = usePaywall();
  const isTrialExpired = trial?.isUserTrialExpired ?? false;
  if (isTrialExpired || trial === null) {
    return null;
  }
  const {
    numberOfFreeTrialDays
  } = trial;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TrialFocusPaywallTitle model={{
      da: "Du er logget ind, men du er ikke tilknyttet et aktivt abonnement",
      de: "Sie sind angemeldet, aber Sie haben kein aktives Abonnement",
      en: "You are logged in, but you are not associated with an active subscription",
      no: "Du er logget inn, men du er ikke tilknyttet et aktivt abonnement",
      sv: "Du \xE4r inloggad, men du har ingen aktiv prenumeration"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="max-w-sm"><Translation da={"Fuld adgang for \xE9n bruger - helt uden kreditkortoplysninger"} de={"Voller Zugriff f\xFCr einen Benutzer - ganz ohne Kreditkarteninformationen"} en="Full access for one user - no credit card information required" no={"Full tilgang for \xE9n bruker - helt uten kredittkortinformasjon"} sv={"Full tillg\xE5ng f\xF6r en anv\xE4ndare - helt utan kreditkortsinformation"} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/profile/add/trial?redirectUrl=${relativeUrl}&type=add-trial`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      contentId: "add-trial",
      contentSource: "paywall",
      contentType: "cta"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `Prøv ${siteName} i ${numberOfFreeTrialDays} dage`;
  const t5 = `Testen Sie ${siteName} für ${numberOfFreeTrialDays} Tage`;
  const t6 = `Try ${siteName} for ${numberOfFreeTrialDays} days`;
  const t7 = `Prøv ${siteName} i ${numberOfFreeTrialDays} dager`;
  const t8 = `Prova ${siteName} i ${numberOfFreeTrialDays} dagar`;
  let t9;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
    t9 = <Translation model={{
      da: t4,
      de: t5,
      en: t6,
      no: t7,
      sv: t8
    }} />;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t2 || $[10] !== t9) {
    t10 = <div className="flex flex-col items-center gap-2">{t0}{t1}<RegularLinkButton href={t2} position="pw-adtr-a" testId="paywall-add-trial" trackingModel={t3}>{t9}</RegularLinkButton></div>;
    $[9] = t2;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}